export default "__VITE_ASSET__MpMH9Nn2__"